import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BitmapText, Container, Sprite } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useCallback, useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { SIDE_BET_ANIMATION_SET, SIDE_BET_NAME_ANIMATION_SET } from '../../../animations/animationDefinitions';
import SIDE_BET_ACTION_IMAGE_URL from '../../../assets/side-bet-action.png';
import { hideSideBetAnimation } from '../../../redux/actions/sideBetsActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { getBitmapTextDimensions } from '../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../utils/utils';
import { AnimationContainer } from '../pixiComponents/animationContainer';
const TEXTURE_SIZE_PX = 256;
const BITMAP_TEXT_STYLE_TYPE = 'side-bet-name-animation';
export const PlayerSideBetAnimationContainer = ({ seatIndex, seatBounds }) => {
    const sideBetAnimation = useAppSelector((state) => state.sideBets.sideBetAnimations[seatIndex], shallowEqual);
    const isSideBettingSettingEnabled = useAppSelector((state) => state.selfData.isSideBettingSettingEnabled);
    const dispatch = useAppDispatch();
    const texture = useMemo(() => PIXI.Texture.from(SIDE_BET_ACTION_IMAGE_URL), []);
    const onAnimationDone = useCallback(() => {
        dispatch(hideSideBetAnimation(seatIndex));
    }, [dispatch, seatIndex]);
    if (!sideBetAnimation) {
        return null;
    }
    const renderedTextureSizePx = Math.min(seatBounds.w, seatBounds.h) / 2;
    let textureScale = renderedTextureSizePx / TEXTURE_SIZE_PX;
    if (!isSideBettingSettingEnabled) {
        // show the animation for non-side-bet players, but make it smaller and less distracting
        textureScale *= 0.5;
    }
    const textureX = -TEXTURE_SIZE_PX / 2;
    const textureY = textureX;
    const { startTimestampMs, bettorPlayerName } = sideBetAnimation;
    const bettorPlayerNameMetrics = isSideBettingSettingEnabled
        ? getBitmapTextDimensions(bettorPlayerName, BITMAP_TEXT_STYLE_TYPE)
        : undefined;
    return (_jsxs(Container, { interactiveChildren: false, "pixi-data": isTestEnvironment() ? { type: 'side-bet-animation', seatIndex } : null, children: [_jsx(Container, { scale: textureScale, children: _jsx(AnimationContainer, { startTimestampMs: startTimestampMs, animationSet: SIDE_BET_ANIMATION_SET, onAnimationDone: onAnimationDone, children: _jsx(Sprite, { texture: texture, x: textureX, y: textureY }) }) }), bettorPlayerNameMetrics && (_jsx(Container, { y: Math.round(renderedTextureSizePx / 2), "pixi-data": isTestEnvironment() ? { type: 'side-bet-name-animation', seatIndex, name: bettorPlayerName } : null, children: _jsx(AnimationContainer, { startTimestampMs: startTimestampMs, animationSet: SIDE_BET_NAME_ANIMATION_SET, children: _jsx(BitmapText, { text: bettorPlayerName, style: { fontName: BITMAP_TEXT_STYLE_TYPE }, x: Math.round(-bettorPlayerNameMetrics.w / 2), y: Math.round(-bettorPlayerNameMetrics.h / 2) }) }) }))] }));
};
